import React, { useEffect, useState } from 'react';
import {
    Layout,
    Breadcrumb,
    Form,
    Select,
    Button,
    Input,
    Typography,
    Row,
    Col,
    Divider,
    Spin,
    Switch,
} from 'antd';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings';
import axios from 'axios';
import { useForm } from 'antd/es/form/Form';
import { AlertError } from '../usableclasses.js';

const { Content } = Layout;
const { Text } = Typography;

const General = () => {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState(null);
    const [stocks, setStocks] = useState([])
    const [form] = useForm();
    const UPDATED_BY = localStorage.getItem("USERID");

    useEffect(() => {
        fetchGeneralSettings();
        fetchDropdowns()
    }, []);

    const fetchDropdowns = async () => {
        try {
            setLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const stock = await axios.get(`${ApiURL}/stocks/all`, { headers });
            setStocks(stock.data);
        } catch (error) {
            console.error('Error fetching dropdowns:', error);
            AlertError('Failed to fetch dropdowns.');
        } finally {
            setLoading(false);
        }
    }

    const onErpSystemChange = async (checked) => {
        try {
            setLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const payload = {
                changeStatus: checked ? "OFF":"ON",
                updatedBy: UPDATED_BY
            }
            await axios.post(`${ApiURL}/settings/erpoperationactivate`, payload, { headers });
            fetchGeneralSettings();
            fetchDropdowns()
        } catch (error) {
            console.error('Error updating ERP system status:', error);
            AlertError("Failed to update ERP system status.");
        } finally {
            setLoading(false);
        }
    };

    const onMlmSystemChange = async (checked) => {
        try {
            setLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const payload = {
                changeStatus: checked ? "OFF":"ON",
                updatedBy: UPDATED_BY
            }
            await axios.post(`${ApiURL}/settings/mlmoperationactivate`, payload, { headers });
            fetchGeneralSettings();
            fetchDropdowns()
        } catch (error) {
            console.error('Error updating MLM system status:', error);
            AlertError("Failed to update MLM system status.");
        } finally {
            setLoading(false);
        }
    };


    const fetchGeneralSettings = async () => {
        try {
            setLoading(true);
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/settings/financialsettings`, { headers });
            const data = response.data;

            setSettings(data);
            form.setFieldsValue({
                defaultConsult: data.defaultConsult,
                salseStockId: data.salseStockId,
            });
        } catch (error) {
            console.error('Error fetching general settings:', error);
            AlertError('Failed to fetch general settings.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        <Breadcrumb.Item>Settings</Breadcrumb.Item>
                        <Breadcrumb.Item>General Settings</Breadcrumb.Item>
                    </Breadcrumb>

                    <div style={{ padding: 10, minHeight: '65vh', background: '#fff', borderRadius: 8 }}>
                        {settings && (
                            <>
                                {/* System Versions */}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}><Text strong>ERP System Version :</Text> {settings.erpFronendVersion}</Col>
                                    <Col span={24}><Text strong>MLM Version :</Text> {settings.mlmWebVersion}</Col>
                                    <Col span={24}><Text strong>Android Version :</Text> {settings.mlmAndroidVersion}</Col>
                                    <Col span={24}><Text strong>IOS Version :</Text> {settings.mlmIosVersion}</Col>
                                </Row>

                                <Divider style={{ borderColor: 'black' }} />

                                {/* Maintain Mode */}
                                <Row gutter={[16, 16]}>
                                    <Col span={24}><Text strong>Maintain Mode</Text></Col>
                                    <Col span={24}>
                                        <Row gutter={16}>
                                            <Col><Text strong>ERP System :</Text></Col>
                                            <Col>
                                                <Switch
                                                    checkedChildren="Yes"
                                                    unCheckedChildren="No"
                                                    checked={settings.isOrderStop}
                                                    onChange={onErpSystemChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row gutter={16}>
                                            <Col><Text strong>MLM System :</Text></Col>
                                            <Col>
                                                <Switch
                                                    checkedChildren="Yes"
                                                    unCheckedChildren="No"
                                                    checked={settings.isMLMStop}
                                                    onChange={onMlmSystemChange}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Divider style={{ borderColor: 'black' }} />

                                {/* Dropdowns */}
                                <Form layout="vertical">
                                    <Row gutter={[16, 16]}>
                                        <Col span={12} xs={24} md={6}>
                                            <Form.Item label={<Text strong>Default Consultant :</Text>}>
                                                <Input
                                                    readOnly={true}
                                                    value={settings.defaultConsult}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12} xs={24} md={6}>
                                            <Form.Item label={<Text strong>Default Sales Stock :</Text>}>
                                                <Input
                                                    readOnly={true}
                                                    value={
                                                        stocks.find(x => x.stockId.toString() === settings.salseStockId.toString())?.stockName
                                                        || `Stock ID: ${settings.salseStockId}`
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>

                            </>
                        )}
                    </div>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default General;
